import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import movementTypes from 'modules/transactions/constants/movementTypes';
import CustomAsyncSelect from 'modules/_shared/components/CustomAsyncSelect';

import { useReclassificationModal } from '../context/ReclassificationModalContext';
import RangesView from './RangesView';

const ReclassificationHoldingClassMode: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useReclassificationModal();

  const isDisabled =
    data.historyMovements.length > 0 &&
    data.historyMovements.some(
      (movement) =>
        movement.movementType === movementTypes.ENTIRE_CLASS_RECLASSIFICATION
    );

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="class-select-input">
          {t('SelectShareClassToFilter')} <MandatoryField />
        </label>
        <div className="form-control-wrap">
          <CustomAsyncSelect
            id="class-select-input"
            value={data.selectedHoldingClassOption}
            onChange={actions.handleChangeHoldingClass}
            onFetchData={actions.handleFetchHoldingClassByTerm}
            placeholder={t('SearchClass')}
            minimumInputLength={1}
            noDataLabelKey="NoClassesHaveBeenFound"
            loadingLabelKey="LoadingClasses"
            errorLabelKey="ErrorLoadingClasses"
            defaultOptions={data.holdingClassOptions}
            isDisabled={isDisabled}
            isClearable={false}
          />
        </div>
      </div>

      <div className="form-group">
        <div className="custom-control custom-control-xs custom-checkbox">
          <input
            type="checkbox"
            id="checkbox-toggle"
            className="custom-control-input"
            checked={data.isEntireClassReclassification}
            onChange={actions.handleChangeIsEntireClassReclassification}
            disabled={isDisabled}
          />
          <label className="custom-control-label" htmlFor="checkbox-toggle">
            {t('ReclassifyEntireClass')}
          </label>
        </div>
      </div>

      {data.isEntireClassReclassification ? (
        <div className="form-control-wrap">
          <CustomAsyncSelect
            id="new-class-select-input"
            value={data.selectedNewHoldingClassOption}
            onChange={actions.handleChangeNewHoldingClass}
            onFetchData={actions.handleFetchHoldingClassByTerm}
            placeholder={t('SearchClass')}
            minimumInputLength={1}
            noDataLabelKey="NoClassesHaveBeenFound"
            loadingLabelKey="LoadingClasses"
            errorLabelKey="ErrorLoadingClasses"
            defaultOptions={data.holdingClassOptions}
            isDisabled={isDisabled}
          />
        </div>
      ) : (
        <RangesView />
      )}
    </>
  );
};

export default ReclassificationHoldingClassMode;
